import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const CategoryManagementStyled = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  /* .main-content {
    min-width: 1600px;
  } */

  .table-wrapper {
    margin-top: 21px;
    flex-wrap: wrap;
  }

  .table {
    .table-row {
      .id {
        flex: 0 0 13%;
        min-width: 160px;
      }

      .business-group {
        flex: 0 0 18%;
      }

      .service-and-item-group {
        flex: 0 0 25%;
      }

      .update-date {
        flex: 0 0 15%;
      }

      .created-date {
        flex: 0 0 15%;
      }

      .actions {
        flex: 0 0 14%;
        min-width: 130px;
        padding: 14px 0 0 2.5%;
      }

      &.header {
        .actions {
          padding: 9px 0 10px 2.8%;
        }
      }
    }
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
`
